import { useEffect, useState } from "react";
import { Gift } from "lucide-react";
import { getAppSettings } from "../lib/appSettings";
import { useLang } from "../context/LangContext";
import { formatCoins } from "../lib/format";

export default function FirstDepositBanner() {
  const { lang } = useLang();
  const [fd, setFd] = useState(null);
  useEffect(() => { getAppSettings(true).then((data) => setFd(data.first_deposit)).catch(() => {}); }, []);
  if (!fd?.eligible || !(fd.percent > 0) || !(fd.max > 0)) return null;
  return (
    <div className="flex items-center gap-3 rounded-xl border border-fuchsia-500/40 bg-gradient-to-r from-fuchsia-500/15 to-amber-500/10 px-4 py-3" data-testid="first-deposit-banner">
      <Gift size={22} className="text-fuchsia-300 shrink-0" />
      <p className="text-sm font-semibold text-fuchsia-50">
        {lang === "hi"
          ? <>पहली डिपॉज़िट पर <b className="text-amber-300">{fd.percent}% बोनस</b> (ज़्यादा से ज़्यादा {formatCoins(fd.max)})!</>
          : <>Get a <b className="text-amber-300">{fd.percent}% bonus</b> on your first deposit (up to {formatCoins(fd.max)})!</>}
      </p>
    </div>
  );
}
